var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.083A9.916 9.916 0 002.083 12 9.916 9.916 0 0012 21.917 9.916 9.916 0 0021.917 12 9.916 9.916 0 0012 2.083zm0-1.75C18.445.333 23.667 5.557 23.667 12c0 6.445-5.224 11.667-11.667 11.667C5.555 23.667.333 18.443.333 12 .333 5.555 5.557.333 12 .333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.583 14.333a.875.875 0 11-1.75 0v-.442c0-1.264.576-1.92 1.846-2.66-.032.019.371-.214.477-.277 1.071-.64 1.469-1.195 1.469-2.48 0-1.445-1.006-2.374-2.917-2.374-1.747 0-2.916 1.352-2.916 2.916a.875.875 0 01-1.75 0c0-2.479 1.892-4.666 4.666-4.666 2.848 0 4.667 1.68 4.667 4.125 0 1.981-.768 3.054-2.322 3.981-.119.071-.536.312-.493.287-.786.458-.977.675-.977 1.148v.442zM11.65 19a1.167 1.167 0 110-2.333 1.167 1.167 0 010 2.333z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHelp);
export default __webpack_public_path__ + "static/media/ic_help.fdb6ebf4610d05776a144bd283e28123.svg";
export { ForwardRef as ReactComponent };